<template>
  <section class="cover">
    <section class="banner">
      <div class="banner-left">
        <img src="../assets/oa-logo.png" alt="Oxytocin Actually" />
      </div>

      <div class="banner-right">
        <div class="play-by">
          <p class="play-by-one">New original play</p>
          <p class="play-by-two">by</p>
          <p class="play-by-three">Wendy Pagler</p>
        </div>
        <div class="teaser">
          How a hormone helps with <span class="red">connections</span>,
          <span class="red">health</span> and
          <span class="red">happiness</span>: an entertaining and comical
          exploration
        </div>
        <div class="some-links">
          <a
            href="https://www.facebook.com/BATS.NO"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/fb.png" alt="Facebook" />
          </a>
          <a
            href="https://www.instagram.com/bats_theatre_stavanger/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../assets/instagram.png" alt="Instagram" />
          </a>
        </div>
      </div>
    </section>

    <nav class="navigation">
      <a>Tickets and dates below</a>
    </nav>
  </section>
</template>

<script>
export default {
  name: "Cover",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #444444;
}

.red {
  font-weight: bold;
  color: #ef4037;
}

.teaser {
  font-size: 30px;
  max-width: 800px;
}

.cover {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.banner {
  display: flex;
  flex-direction: column;
  flex-basis: 50%;
  flex: 1 1 auto;
  justify-self: center;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.some-links {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.some-links img {
  width: 30px;
  height: 30px;
  margin: 10px;
}

@media screen and (min-width: 768px) {
  .banner {
    flex-direction: row;
  }

  .banner > div {
    max-width: 50%;
  }
}

.banner-right {
  display: flex;
  flex-direction: column;
}

.banner-left img {
  max-width: 80%;
}

.banner-left img {
  padding: 30px;
}

nav {
  padding: 20px;
}

.play-by {
  font-family: Open Sans;
  font-style: normal;
  font-weight: bold;
  text-align: center;
  color: #444444;
}

.play-by-one {
  font-size: 14px;
  line-height: 19px;
  /* identical to box height */

  letter-spacing: 0.37em;
  text-transform: uppercase;
}

.play-by-two {
  font-style: normal;
  font-weight: 800;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.37em;
  display: inline-flex;
  text-transform: uppercase;
}

.play-by-two::before,
.play-by-two::after {
  content: " ";
  width: 50px;
  height: 1px;
  background-color: black;
  display: block;
  position: relative;
  top: 6px;
  margin: 0 8px;
}

.play-by-three {
  font-size: 20px;
  line-height: 27px;
}
</style>
